import React, {Component} from 'react'
import PropTypes from "prop-types";


class TreatmentIntakeMethod extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    componentDidMount() {
    }



    editTreatmentPlan = (func,value,index) => {
        this.props.editTreatmentPlan(func,value,index)
        if(value!=="Other"){
            this.props.changeView(2)

        }
    }

    render() {
        let {t}=this.props
        let currentEntry= this.props.current?this.props.current:""
        return (
            <div style={{display:this.props.view===1?'block':'none'}}>
                <div className={"treatment-plan-boxes-title"}> {t('patient_boarding.Intake_method')}</div>
            <div className={"select-method-options"}>
                    <div className={currentEntry.TreatmentIntakeMethod ==="Flower" ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", "Flower",this.props.index)}>
                        {t('patient_boarding.Flower')}</div>

                    <div className={currentEntry.TreatmentIntakeMethod === "Oil drops" ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", "Oil drops",this.props.index)}>
                        {t('patient_boarding.Oil_drops')} </div>

              {/*  <div className={currentEntry.TreatmentIntakeMethod ===t('patient_boarding.Flower_smoking') ? "select-method-option-selected" :"select-method-option" }
                     onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", t('patient_boarding.Flower_smoking'),this.props.index)}>
                    {t('patient_boarding.Flower_smoking')}</div>
                    <div className={currentEntry.TreatmentIntakeMethod ===t('patient_boarding.Oil_vape') ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", t('patient_boarding.Oil_vape'),this.props.index)}>
                        {t('patient_boarding.Oil_vape')}
                    </div>*/}
                    </div>
                <div className={"select-method-options"}>
                    <div className={currentEntry.TreatmentIntakeMethod ==="Precision Dosing Devices" ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", "Precision Dosing Devices",this.props.index)}>
                        {t('patient_boarding.Precision_Dosing_Devices')}</div>

                    <div className={currentEntry.TreatmentIntakeMethod ==="Other" ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", "Other",this.props.index)}>
                        {t('patient_boarding.other')}</div>

                    <select style={{display: currentEntry.TreatmentIntakeMethod ==="Other" ? 'block' : 'none'}}
                            className={'selectBox-intakeMethod'} id="Other_treatment_intake_method"
                            name="product_type" value={currentEntry.Other_treatment_intake_method}
                            onChange={(event) => this.editTreatmentPlan("Other_treatment_intake_method", event.target.value,this.props.index)}>
                        <option/>
                        <option value={"Oil Vape"}>{t('patient_boarding.Oil_vape')}</option>
                        <option value={"Flower Smoking"}>{t('patient_boarding.Flower_smoking')}</option>
                        <option value={"Edible"}>{t('patient_boarding.Edible')}</option>
                    </select>

                    <div className={"select-method-option-empty"}/>

{/*
                <div className={currentEntry.TreatmentIntakeMethod ===t('patient_boarding.Edible') ? "select-method-option-selected" :"select-method-option" }
                     onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", t('patient_boarding.Edible'),this.props.index)}>
                    {t('patient_boarding.Edible')}</div>

                <div className={currentEntry.TreatmentIntakeMethod ===t('patient_boarding.other') ? "select-method-option-selected" :"select-method-option" }
                     onClick={(event) => this.editTreatmentPlan("TreatmentIntakeMethod", t('patient_boarding.other'),this.props.index)}>
                    {t('patient_boarding.other')}</div>
                    <div className={"select-method-option-empty"}
                    style={{display: currentEntry.TreatmentIntakeMethod !==t('patient_boarding.other') ?'block':'none'}}/>

                <input type="text"
                       className={currentEntry.TreatmentIntakeMethod ===t('patient_boarding.other')?"select-method-option-other":"select-method-option-other-not-selected"}
                       value={currentEntry.Other_treatment_intake_method}
                       onChange={(event) => this.editTreatmentPlan("Other_treatment_intake_method", event.target.value,this.props.index)}/>*/}
            </div>

            </div>

        )
    }
}

TreatmentIntakeMethod.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TreatmentIntakeMethod;
